// extracted by mini-css-extract-plugin
module.exports = {"main":"Info_main__3YX5Q","main__title":"Info_main__title__LJuA9","main__info":"Info_main__info__1yeQj"};